import React, { useState } from 'react';
import { IconButton } from '@mui/material';
import { ArrowUpward } from '@mui/icons-material';
import { UPGRADE_SUBSCRIPTION, UPGRADE_DIALOG_QUERY, GET_SUBSCRIPTIONS } from './UsersInLicense.graphql';
import { useMutation, useLazyQuery } from '@apollo/client/react';
import { Subscription, LicenseSubscription } from '../../interfaces';
import UpgradeSubscriptionDialog from './UpgradeSubscriptionDialog';
export function UpgradeSubscriptionButton({
  access,
  target,
  upgradingToTarget,
}: {
  access: LicenseSubscription;
  target: Subscription;
  /** The subscriptions that upgrade to the target, whose rows the upgrade replaces. */
  upgradingToTarget: number[];
}) {
  const [open, setOpen] = useState(false);
  const [upgradeSubscription] = useMutation<any, any>(UPGRADE_SUBSCRIPTION);
  const [getUpgradeData, { loading, data }] = useLazyQuery<any, any>(UPGRADE_DIALOG_QUERY, {
    fetchPolicy: 'network-only',
  });
  const handleOpen = () => {
    setOpen(true);
    getUpgradeData({ variables: { id: access.licenseId, subscriptionId: access.subscription.id } });
  };
  const submit = (numberOfAccesses: number) => {
    upgradeSubscription({
      variables: {
        input: {
          id: access.licenseId,
          fromSubscriptionId: access.subscription.id,
          toSubscriptionId: target.id,
          numberOfAccesses,
        },
      },
      update(cache) {
        const queryVariable = { id: access.licenseId };
        const result = cache.readQuery({ query: GET_SUBSCRIPTIONS, variables: queryVariable }) as any;

        cache.writeQuery({
          query: GET_SUBSCRIPTIONS,
          variables: queryVariable,
          data: {
            subscriptions: result.subscriptions
              .filter((x) => !upgradingToTarget.includes(x.subscription.id))
              .concat({
                ...access,
                id: `${access.licenseId}:${target.id}`,
                subscription: target,
                numberOfUsers: numberOfAccesses,
              }),
            paidSubscriptions: result.paidSubscriptions,
            license: result.license,
          },
        });
      },
    });
    setOpen(false);
  };
  return (
    <>
      <IconButton onClick={handleOpen} title="Oppgradér" size="large">
        <ArrowUpward />
      </IconButton>
      {data && !loading && (
        <UpgradeSubscriptionDialog
          open={open}
          parentName={target.name}
          message={data.upgradeDialog.message}
          accessCount={data.upgradeDialog.accessCount}
          sumFreeSeats={data.upgradeDialog.sumFreeSeats}
          maxFreeSeats={data.upgradeDialog.maxFreeSeats}
          onCancel={() => setOpen(false)}
          onSubmit={submit}
        />
      )}
    </>
  );
}
